import Icon from '@ant-design/icons'

export const IconCorrect = () => (
  <svg
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1em"
    height="1em"
  >
    <title>confirm</title>
    <g id="全局样式" stroke="none" strokeWidth="1.5" fill="none" fillRule="evenodd">
      <g id="基础" transform="translate(-824.000000, -2515.000000)">
        <g id="confirm" transform="translate(824.000000, 2515.000000)">
          <polygon
            id="路径"
            fillOpacity="0.05"
            fill="#ffffff"
            opacity="0.05"
            points="0 0 24 0 24 24 0 24"
          ></polygon>
          <polygon
            id="路径"
            fill="currentColor"
            points="19.6464466 6.14644661 20.3535534 6.85355339 10 17.2071068 4.14644661 11.3535534 4.85355339 10.6464466 10 15.793"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
)

export const PasswordVisibleIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z"
      fill="currentColor"
    />
  </svg>
)

export const PasswordHiddenIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2954 6.31083C22.6761 6.474 22.8524 6.91491 22.6893 7.29563L21.9999 7.00019C22.6893 7.29563 22.6894 7.29546 22.6893 7.29563L22.6886 7.29731L22.6875 7.2998L22.6843 7.30716L22.6736 7.33123C22.6646 7.35137 22.6518 7.37958 22.6352 7.41527C22.6019 7.48662 22.5533 7.58794 22.4888 7.71435C22.3599 7.967 22.1675 8.32087 21.9084 8.73666C21.4828 9.4197 20.8724 10.2778 20.0619 11.1304L21.0303 12.0987C21.3231 12.3916 21.3231 12.8665 21.0303 13.1594C20.7374 13.4523 20.2625 13.4523 19.9696 13.1594L18.969 12.1588C18.3093 12.7115 17.5528 13.2302 16.695 13.6564L17.6286 15.0912C17.8545 15.4383 17.7562 15.9029 17.409 16.1288C17.0618 16.3547 16.5972 16.2564 16.3713 15.9092L15.2821 14.2353C14.5028 14.4898 13.659 14.6628 12.7499 14.7248V16.5002C12.7499 16.9144 12.4141 17.2502 11.9999 17.2502C11.5857 17.2502 11.2499 16.9144 11.2499 16.5002V14.7248C10.3689 14.6647 9.54909 14.5004 8.78982 14.2586L7.71575 15.9093C7.48984 16.2565 7.02526 16.3548 6.67807 16.1289C6.33089 15.903 6.23257 15.4384 6.45847 15.0912L7.37089 13.689C6.5065 13.2668 5.74381 12.7504 5.07842 12.1984L4.11744 13.1594C3.82455 13.4523 3.34968 13.4523 3.05678 13.1594C2.76389 12.8665 2.76389 12.3917 3.05678 12.0988L3.98055 11.175C3.15599 10.3153 2.53525 9.44675 2.10277 8.75486C1.83984 8.33423 1.6446 7.97584 1.51388 7.71988C1.44848 7.59182 1.3991 7.48914 1.36537 7.41683C1.3485 7.38067 1.33553 7.35207 1.32641 7.33167L1.31562 7.30729L1.31238 7.29984L1.31129 7.29733L1.31088 7.29638C1.31081 7.2962 1.31056 7.29563 1.99992 7.00019L1.31088 7.29638C1.14772 6.91565 1.32376 6.474 1.70448 6.31083C2.08489 6.1478 2.52539 6.32374 2.68888 6.70381C2.68882 6.70368 2.68894 6.70394 2.68888 6.70381L2.68983 6.706L2.69591 6.71972C2.7018 6.73291 2.7114 6.7541 2.72472 6.78267C2.75139 6.83983 2.79296 6.92644 2.84976 7.03767C2.96345 7.26029 3.13762 7.58046 3.37472 7.95979C3.85033 8.72067 4.57157 9.70728 5.55561 10.6218C6.42151 11.4265 7.48259 12.1678 8.75165 12.656C9.70614 13.0232 10.7854 13.2502 11.9999 13.2502C13.2416 13.2502 14.342 13.013 15.3124 12.631C16.5738 12.1345 17.6277 11.3884 18.4866 10.5822C19.4562 9.67216 20.1668 8.69535 20.6354 7.9434C20.869 7.5685 21.0405 7.25246 21.1525 7.03286C21.2085 6.92315 21.2494 6.83776 21.2757 6.78144C21.2888 6.75328 21.2983 6.73242 21.3041 6.71943L21.31 6.70595L21.3106 6.70475C21.3105 6.70485 21.3106 6.70466 21.3106 6.70475M22.2954 6.31083C21.9147 6.14771 21.4738 6.32423 21.3106 6.70475L22.2954 6.31083ZM2.68888 6.70381C2.68882 6.70368 2.68894 6.70394 2.68888 6.70381V6.70381Z"
      fill="currentColor"
    />
  </svg>
)

export const PinPush = () => (
  <Icon
    component={() => (
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M232.49 84.2L171.8 23.51a12 12 0 0 0-17 0L99.45 79.07c-8.08-3-32.79-9.45-59 11.67a12 12 0 0 0-1 17.84l51.13 51.13-45.41 45.46a4 4 0 0 0 5.66 5.66l45.46-45.47 51.12 51.12a12 12 0 0 0 8.49 3.52h.85a12 12 0 0 0 8.73-4.74c19.83-26.36 16.51-47.18 11.71-58.57l55.3-55.49a12 12 0 0 0 0-17zm-5.66 11.31L169.56 153a4 4 0 0 0-.75 4.61c10.43 20.85-1.62 42-9.73 52.83a4 4 0 0 1-6 .4L45.17 102.93a4 4 0 0 1 .33-6c12.94-10.4 25.36-13.19 34.94-13.19a43.9 43.9 0 0 1 18.16 3.64 4 4 0 0 0 4.62-.75l57.27-57.46a4 4 0 0 1 5.66 0l60.68 60.69a4 4 0 0 1 0 5.65z"
        />
      </svg>
    )}
  />
)

export const PinSlash = () => (
  <Icon
    component={() => (
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M51 37.31a4 4 0 0 0-6 5.38L75.35 76c-9.93.88-22.26 4.54-34.87 14.71a12 12 0 0 0-1 17.84l51.13 51.13-45.44 45.49a4 4 0 0 0 5.66 5.66l45.46-45.47 51.12 51.12a12 12 0 0 0 8.49 3.52h.85a12 12 0 0 0 8.73-4.74 81.06 81.06 0 0 0 13.19-25.55l26.37 29a4 4 0 1 0 5.92-5.38zm108.08 173.11a4 4 0 0 1-6 .4L45.17 102.93a4 4 0 0 1 .33-6c14.08-11.36 27.62-13.5 37-13.12l89.69 98.65c-2.12 11.46-8.19 21.46-13.11 27.96zm73.41-109.25L187.85 146a4 4 0 0 1-5.67-5.64l44.65-44.8a4 4 0 0 0 0-5.66l-60.68-60.73a4 4 0 0 0-5.66 0l-41.22 41.36a4 4 0 0 1-5.67-5.65l41.23-41.36a12 12 0 0 1 17 0l60.66 60.68a12 12 0 0 1 0 16.97z"
        />
      </svg>
    )}
  />
)

export const MenuTodo = () => (
  <svg
    className="icon"
    width="1em"
    height="1em"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M704 888.889H149.333c-31.289 0-56.889-25.6-56.889-56.889V192c0-31.289 25.6-56.889 56.89-56.889h725.333c31.289 0 56.889 25.6 56.889 56.889v640c0 31.289-25.6 56.889-56.89 56.889H704z"
      fill="#5CBAEA"
    />
    <path
      d="M704 888.889H149.333c-31.289 0-56.889-25.6-56.889-56.889V192c0-31.289 25.6-56.889 56.89-56.889h725.333c31.289 0 56.889 25.6 56.889 56.889v469.333L704 888.89z"
      fill="#FFF"
    />
    <path
      d="M92.444 305.778V192c0-31.289 25.6-56.889 56.89-56.889h725.333c31.289 0 56.889 25.6 56.889 56.889v113.778H92.444z"
      fill="#FFC44F"
    />
    <path
      d="M704 888.889V718.222c0-31.289 25.6-56.889 56.889-56.889h170.667L704 888.89z"
      fill="#FFF"
    />
    <path
      d="M284.444 497.778h455.112c15.644 0 28.444-12.8 28.444-28.445s-12.8-28.444-28.444-28.444H284.444c-15.644 0-28.444 12.8-28.444 28.444s12.8 28.445 28.444 28.445z"
      fill="#194F82"
    />
    <path
      d="M874.667 106.667H149.333c-23.466 0-44.8 9.244-60.444 24.889S64 168.533 64 192v640c0 46.933 38.4 85.333 85.333 85.333h725.334C921.6 917.333 960 878.933 960 832V192c0-46.933-38.4-85.333-85.333-85.333zM903.11 832c0 15.644-12.8 28.444-28.444 28.444h-101.69l130.134-130.133V832zm-170.667-12.089V718.222c0-15.644 12.8-28.444 28.445-28.444h101.689L732.444 819.91zM903.111 632.89H760.89c-46.933 0-85.333 38.4-85.333 85.333v142.222H149.333c-15.644 0-28.444-12.8-28.444-28.444V334.222H903.11V632.89zm0-355.556H120.89V192c0-7.822 2.844-14.933 8.533-19.911 4.978-4.978 12.09-8.533 19.911-8.533h725.334c15.644 0 28.444 12.8 28.444 28.444v85.333z"
      fill="#194F82"
    />
    <path
      d="M611.556 625.778H284.444c-15.644 0-28.444-12.8-28.444-28.445s12.8-28.444 28.444-28.444h327.112c15.644 0 28.444 12.8 28.444 28.444s-12.8 28.445-28.444 28.445zm-156.445 128H284.444c-15.644 0-28.444-12.8-28.444-28.445s12.8-28.444 28.444-28.444h170.667c15.645 0 28.445 12.8 28.445 28.444s-12.8 28.445-28.445 28.445z"
      fill="#194F82"
    />
  </svg>
)

export const MenuWork = () => (
  <svg
    className="icon"
    width="1em"
    height="1em"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M704 512c106.667 0 192-85.333 192-192s-85.333-192-192-192-192 85.333-192 192c0-106.667-85.333-192-192-192s-192 85.333-192 192 85.333 192 192 192c-106.667 0-192 85.333-192 192 0 21.333 4.267 42.667 12.8 64l12.8 25.6v4.267c4.267 8.533 8.533 17.066 12.8 21.333v4.267c8.533 12.8 21.333 25.6 34.133 34.133 4.267 0 4.267 4.267 4.267 4.267 4.267 4.266 8.533 4.266 12.8 8.533 4.267 4.267 8.533 4.267 17.067 8.533 4.266 0 8.533 4.267 12.8 4.267 8.533 4.267 12.8 4.267 21.333 8.533 4.267 0 8.533 0 12.8 4.267H320c12.8 0 25.6 0 34.133-4.267 4.267 0 8.534 0 12.8-4.266 8.534 0 12.8-4.267 21.334-8.534 4.266 0 8.533-4.266 12.8-4.266 4.266-4.267 12.8-4.267 17.066-8.534 4.267-4.266 8.534-4.266 12.8-8.533 4.267 0 4.267-4.267 4.267-4.267C448 844.8 460.8 832 469.333 819.2v-4.267c4.267-8.533 8.534-12.8 12.8-21.333v-4.267l12.8-25.6c8.534-21.333 12.8-42.666 12.8-64 0 21.334 4.267 42.667 12.8 64l12.8 25.6v4.267c4.267 8.533 8.534 17.067 12.8 21.333v4.267c8.534 12.8 21.334 25.6 34.134 34.133 4.266 0 4.266 4.267 4.266 4.267 4.267 4.267 8.534 4.267 12.8 8.533 4.267 4.267 8.534 4.267 17.067 8.534 4.267 0 8.533 4.266 12.8 4.266 8.533 4.267 12.8 4.267 21.333 8.534 4.267 0 8.534 0 12.8 4.266 12.8 0 21.334 4.267 34.134 4.267s25.6 0 34.133-4.267c4.267 0 8.533 0 12.8-4.266 8.533 0 12.8-4.267 21.333-8.534 4.267 0 8.534-4.266 12.8-4.266 4.267-4.267 12.8-4.267 17.067-8.534s8.533-4.266 12.8-8.533c4.267 0 4.267-4.267 4.267-4.267 12.8-8.533 25.6-21.333 34.133-34.133v-4.267c4.267-8.533 8.533-12.8 12.8-21.333v-4.267l12.8-25.6c8.533-21.333 12.8-42.666 12.8-64C896 597.333 810.667 512 704 512zM554.667 320c0-81.067 68.266-149.333 149.333-149.333S853.333 238.933 853.333 320 785.067 469.333 704 469.333H554.667V320zm-384 0c0-81.067 68.266-149.333 149.333-149.333S469.333 238.933 469.333 320v149.333H320c-81.067 0-149.333-68.266-149.333-149.333zm17.066 448c-12.8-21.333-17.066-42.667-17.066-64 0-81.067 68.266-149.333 149.333-149.333h149.333V704c0 21.333-4.266 42.667-17.066 64H187.733zm366.934-64V554.667H704c81.067 0 149.333 68.266 149.333 149.333 0 21.333-4.266 42.667-17.066 64h-268.8c-8.534-21.333-12.8-42.667-12.8-64z"
      fill="#4189FF"
    />
  </svg>
)

export const MenuAssistant = () => (
  <svg
    className="icon"
    width="1em"
    height="1em"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M296.14 592.282a61.645 61.645 0 1 0 123.25 0 61.645 61.645 0 0 0-123.29 0z"
      fill="#4189FF"
    />
    <path
      d="M943.636 435.405C879.78 284.672 707.706 175.8 504.013 171.459V69.018a34.98 34.98 0 1 0-16.343 0v102.44C281.723 172.852 106.619 281.028 40.755 432.17 16.261 441.221 0 464.569 0 490.701v185.712c0 34.448 27.935 62.423 62.423 62.423h9.626v-304.66c63.774-138.199 225.69-236.667 415.62-237.978v38.42l-35.716 20.645a350.33 350.33 0 0 1-114.934 42.803 278.528 278.528 0 0 0-230.072 274.268v32.03a278.528 278.528 0 0 0 136.888 239.863c-45.343 18.964-72.54 43.171-72.54 69.55 0 60.825 144.752 110.264 323.338 110.264s323.338-49.357 323.338-110.264c0-26.092-26.624-50.013-71.024-68.936a278.528 278.528 0 0 0 137.912-240.476v-32.03a278.528 278.528 0 0 0-233.022-274.802 299.008 299.008 0 0 1-101.17-36.044l-46.572-26.952v-38.175c192.757 4.342 355.123 108.626 413.163 252.109v295.158h9.626a62.423 62.423 0 0 0 62.423-62.423V495.534c0-28.017-18.678-52.593-45.67-60.088zm-209.223 12.001a49.562 49.562 0 0 1 49.602 49.644v220.897a49.562 49.562 0 0 1-49.602 49.602h-477.02a49.603 49.603 0 0 1-49.603-49.602V497.05a49.603 49.603 0 0 1 49.603-49.644h477.02z"
      fill="#4189FF"
    />
    <path
      d="M577.864 592.282a61.645 61.645 0 1 0 123.248 0 61.645 61.645 0 0 0-123.29 0z"
      fill="#4189FF"
    />
  </svg>
)

export const LoginLogo = () => (
  <svg width="42" height="30" viewBox="0 0 42 30" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.287 0l-8.643 1.762 18.537 20.269L42 9.004 30.287 0zm-5.762 6.36l-3.563-4.023-5.345 4.751 3.374 4.176 5.534-4.904zm.38 16.13l4.813 6.935 9.704-6.858-6.103-6.705-8.415 6.628zM10.84 3.87L4.852 4.98l13.76 22.913L28.96 30 17.702 13.678l-6.86-9.808zM6.634 9.693L4.32 5.747l-3.146 4.674 2.16 3.755 3.299-4.483zm.682 11.38l2.691 4.75 2.805-2.95-2.843-4.712-2.653 2.912zM0 17.586l3.904 7.433 5.497 1.456L.72 11.15 0 17.586z"
      fill="#458DFF"
      fillRule="nonzero"
    />
  </svg>
)

export const MainLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3.2002 20.0004C3.2002 20.2213 3.37928 20.4004 3.6002 20.4004L15.6002 20.4004V17.2004H3.2002L3.2002 20.0004Z"
        fill="url(#paint0_linear_2248_32082)"
      />
      <path d="M17.2002 20.4004H20.4002V17.2004H17.2002V20.4004Z" fill="white" />
      <path
        d="M4.0002 8.80078C3.55837 8.80078 3.2002 9.15895 3.2002 9.60078L3.20019 20.0008C3.20019 20.2217 3.37928 20.4008 3.60019 20.4008L6.4002 20.4008L6.4002 8.80078L4.0002 8.80078Z"
        fill="white"
      />
      <path
        d="M12.0397 2.4006L3.19966 7.42857L3.19966 11.2006L12.0397 5.92572L12.0397 2.4006Z"
        fill="white"
      />
      <path
        d="M12.0332 2.40039L20.7419 7.42837L20.7419 11.2004L12.0332 6.00039L12.0332 2.40039Z"
        fill="url(#paint1_linear_2248_32082)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2248_32082"
          x1="15.6002"
          y1="18.8004"
          x2="6.65593"
          y2="18.8004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2248_32082"
          x1="12"
          y1="6"
          x2="17.5047"
          y2="9.49253"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const NaviIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="&#229;&#155;&#190;&#230;&#160;&#135;16px/&#229;&#175;&#188;&#232;&#136;&#170;">
        <g id="Union">
          <path
            d="M3.5 3C3.5 2.72386 3.27614 2.5 3 2.5C2.72386 2.5 2.5 2.72386 2.5 3C2.5 3.27614 2.72386 3.5 3 3.5C3.27614 3.5 3.5 3.27614 3.5 3Z"
            fill="currentColor"
          />
          <path
            d="M8.5 3C8.5 2.72386 8.27614 2.5 8 2.5C7.72386 2.5 7.5 2.72386 7.5 3C7.5 3.27614 7.72386 3.5 8 3.5C8.27614 3.5 8.5 3.27614 8.5 3Z"
            fill="currentColor"
          />
          <path
            d="M13.5 3C13.5 2.72386 13.2761 2.5 13 2.5C12.7239 2.5 12.5 2.72386 12.5 3C12.5 3.27614 12.7239 3.5 13 3.5C13.2761 3.5 13.5 3.27614 13.5 3Z"
            fill="currentColor"
          />
          <path
            d="M13.5 8C13.5 7.72386 13.2761 7.5 13 7.5C12.7239 7.5 12.5 7.72386 12.5 8C12.5 8.27614 12.7239 8.5 13 8.5C13.2761 8.5 13.5 8.27614 13.5 8Z"
            fill="currentColor"
          />
          <path
            d="M8.5 8C8.5 7.72386 8.27614 7.5 8 7.5C7.72386 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.72386 8.5 8 8.5C8.27614 8.5 8.5 8.27614 8.5 8Z"
            fill="currentColor"
          />
          <path
            d="M3.5 8C3.5 7.72386 3.27614 7.5 3 7.5C2.72386 7.5 2.5 7.72386 2.5 8C2.5 8.27614 2.72386 8.5 3 8.5C3.27614 8.5 3.5 8.27614 3.5 8Z"
            fill="currentColor"
          />
          <path
            d="M3.5 13C3.5 12.7239 3.27614 12.5 3 12.5C2.72386 12.5 2.5 12.7239 2.5 13C2.5 13.2761 2.72386 13.5 3 13.5C3.27614 13.5 3.5 13.2761 3.5 13Z"
            fill="currentColor"
          />
          <path
            d="M8.5 13C8.5 12.7239 8.27614 12.5 8 12.5C7.72386 12.5 7.5 12.7239 7.5 13C7.5 13.2761 7.72386 13.5 8 13.5C8.27614 13.5 8.5 13.2761 8.5 13Z"
            fill="currentColor"
          />
          <path
            d="M13.5 13C13.5 12.7239 13.2761 12.5 13 12.5C12.7239 12.5 12.5 12.7239 12.5 13C12.5 13.2761 12.7239 13.5 13 13.5C13.2761 13.5 13.5 13.2761 13.5 13Z"
            fill="currentColor"
          />
          <path
            d="M3.5 3C3.5 2.72386 3.27614 2.5 3 2.5C2.72386 2.5 2.5 2.72386 2.5 3C2.5 3.27614 2.72386 3.5 3 3.5C3.27614 3.5 3.5 3.27614 3.5 3Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M8.5 3C8.5 2.72386 8.27614 2.5 8 2.5C7.72386 2.5 7.5 2.72386 7.5 3C7.5 3.27614 7.72386 3.5 8 3.5C8.27614 3.5 8.5 3.27614 8.5 3Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M13.5 3C13.5 2.72386 13.2761 2.5 13 2.5C12.7239 2.5 12.5 2.72386 12.5 3C12.5 3.27614 12.7239 3.5 13 3.5C13.2761 3.5 13.5 3.27614 13.5 3Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M13.5 8C13.5 7.72386 13.2761 7.5 13 7.5C12.7239 7.5 12.5 7.72386 12.5 8C12.5 8.27614 12.7239 8.5 13 8.5C13.2761 8.5 13.5 8.27614 13.5 8Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M8.5 8C8.5 7.72386 8.27614 7.5 8 7.5C7.72386 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.72386 8.5 8 8.5C8.27614 8.5 8.5 8.27614 8.5 8Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M3.5 8C3.5 7.72386 3.27614 7.5 3 7.5C2.72386 7.5 2.5 7.72386 2.5 8C2.5 8.27614 2.72386 8.5 3 8.5C3.27614 8.5 3.5 8.27614 3.5 8Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M3.5 13C3.5 12.7239 3.27614 12.5 3 12.5C2.72386 12.5 2.5 12.7239 2.5 13C2.5 13.2761 2.72386 13.5 3 13.5C3.27614 13.5 3.5 13.2761 3.5 13Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M8.5 13C8.5 12.7239 8.27614 12.5 8 12.5C7.72386 12.5 7.5 12.7239 7.5 13C7.5 13.2761 7.72386 13.5 8 13.5C8.27614 13.5 8.5 13.2761 8.5 13Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M13.5 13C13.5 12.7239 13.2761 12.5 13 12.5C12.7239 12.5 12.5 12.7239 12.5 13C12.5 13.2761 12.7239 13.5 13 13.5C13.2761 13.5 13.5 13.2761 13.5 13Z"
            stroke="currentColor"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  )
}

export const MenuCollapseArrow = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="&#229;&#155;&#190;&#230;&#160;&#135;16px/&#231;&#174;&#173;&#229;&#164;&#180;/2&#229;&#143;&#140;&#231;&#174;&#173;&#229;&#164;&#180;/DoubleLeft &#229;&#144;&#145;&#229;&#183;&#166;&#229;&#143;&#140;&#231;&#174;&#173;&#229;&#164;&#180;">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.93646 3.17061L3.1081 5.99897L5.937 8.82679L5.23003 9.53403L2.04744 6.35266L1.69376 5.9991L2.04738 5.64548L5.22936 2.4635L5.93646 3.17061ZM9.92157 3.17061L7.09321 5.99897L9.92211 8.82679L9.21513 9.53403L6.03255 6.35266L5.67886 5.9991L6.03248 5.64548L9.21446 2.4635L9.92157 3.17061Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export const MenuSetting = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.64836 0.794922H6.24266L6.15908 1.19191L5.76969 3.04149C5.60536 3.11561 5.44546 3.19773 5.29048 3.28735L5.29046 3.28732C5.13476 3.377 4.98313 3.47474 4.83624 3.58037L3.03976 2.99281L2.65417 2.86669L2.45132 3.21803L1.12135 5.52161L0.918503 5.87295L1.22052 6.14383L2.6276 7.40584C2.60961 7.5854 2.60078 7.76513 2.60092 7.94434H2.60087C2.60071 8.12383 2.60954 8.30384 2.62755 8.48368L1.22047 9.74569L0.918457 10.0166L1.1213 10.3679L2.45128 12.6715L2.65412 13.0228L3.03972 12.8967L4.83619 12.3092C4.98285 12.4146 5.13425 12.5122 5.28969 12.6018L5.28968 12.6018C5.44491 12.6916 5.60508 12.7739 5.76969 12.8481L6.15908 14.6977L6.24266 15.0947H6.64836H9.3083H9.71399L9.79757 14.6977L10.187 12.8481C10.3516 12.7739 10.5117 12.6916 10.667 12.6018L10.1662 11.7362C9.97593 11.8463 9.77663 11.9424 9.56974 12.0232L9.31802 12.1215L9.26235 12.3859L8.9026 14.0947H7.05405L6.69431 12.3859L6.63863 12.1215L6.38692 12.0232C6.18002 11.9424 5.98072 11.8463 5.79041 11.7362L5.51437 12.2134L5.78952 11.7357C5.59876 11.6258 5.41562 11.5011 5.24197 11.3622L5.03098 11.1933L4.77414 11.2773L3.11445 11.8201L2.19018 10.2192L3.49012 9.05333L3.69129 8.8729L3.65057 8.60576C3.61707 8.38605 3.60067 8.16526 3.60087 7.94527L3.09235 7.9448L3.60092 7.94432C3.60071 7.72431 3.61711 7.50349 3.65061 7.28376L3.69134 7.01662L3.49017 6.83619L2.19022 5.67027L3.1145 4.06938L4.77419 4.6122L5.03103 4.6962L5.24202 4.52736C5.41566 4.38841 5.59881 4.26373 5.78957 4.15386L5.53594 3.71351L5.79041 4.15342C5.98072 4.04333 6.18002 3.9472 6.38692 3.8664L6.63863 3.7681L6.69431 3.50366L7.05405 1.79492H8.9026L9.26235 3.50366L9.31802 3.7681L9.56974 3.8664C9.77663 3.9472 9.97593 4.04333 10.1662 4.15342L10.4413 3.67786L10.167 4.1541C10.3578 4.26398 10.5409 4.38865 10.7146 4.52761L10.9256 4.69645L11.1824 4.61244L12.4565 4.19574C12.6812 4.12223 12.9267 4.2162 13.0449 4.42096L13.5635 5.31917C13.6801 5.52103 13.6415 5.77615 13.4718 5.9346L12.4665 6.83625L12.2653 7.01668L12.2653 7.0168L12.2653 7.01686L12.306 7.28401C12.3441 7.53386 12.3601 7.78512 12.3547 8.03501L12.3549 8.03501C12.3512 8.22526 12.335 8.41591 12.3061 8.60576L12.2654 8.8729L12.4665 9.05333L13.7665 10.2192L12.8422 11.8201L11.1825 11.2773L10.9257 11.1933L10.7147 11.3622C10.5415 11.5008 10.3588 11.6252 10.1686 11.7348L10.668 12.6012C10.8231 12.5118 10.9741 12.4144 11.1205 12.3092L12.9169 12.8967L13.3025 13.0228L13.5054 12.6715L14.8353 10.3679L15.0382 10.0166L14.7362 9.74569L13.3291 8.48368C13.3471 8.30384 13.3559 8.12383 13.3558 7.94434H13.3557C13.3557 7.86328 13.354 7.7821 13.3503 7.70089L13.3504 7.70088C13.346 7.60262 13.3389 7.5043 13.3291 7.40603L14.1321 6.68583L14.145 6.67411L14.7361 6.14389L15.0382 5.87301L14.8353 5.52167L13.5053 3.21809L13.3025 2.86675L12.9169 2.99286L11.1204 3.58043C10.9741 3.4752 10.8231 3.3778 10.668 3.28841L10.6679 3.28857L10.6669 3.28798L10.667 3.28781C10.5117 3.19802 10.3516 3.11574 10.187 3.04149L9.79757 1.19191L9.71399 0.794922H9.3083H6.64836ZM6.7539 7.99973C6.7539 7.31155 7.31178 6.75368 7.99995 6.75368C8.68813 6.75368 9.24601 7.31155 9.24601 7.99973C9.24601 8.68791 8.68813 9.24578 7.99995 9.24578C7.31178 9.24578 6.7539 8.68791 6.7539 7.99973ZM7.99995 5.75368C6.75949 5.75368 5.7539 6.75927 5.7539 7.99973C5.7539 9.24019 6.75949 10.2458 7.99995 10.2458C9.24041 10.2458 10.246 9.24019 10.246 7.99973C10.246 6.75927 9.24041 5.75368 7.99995 5.75368Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const MenuWorkshop = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.21589 6.82009L7.61589 2.32009C7.8384 2.13467 8.1616 2.13467 8.38411 2.32009L13.7841 6.82009C13.9209 6.93409 14 7.10296 14 7.28102V14.4C14 14.7314 13.7314 15 13.4 15H10.1C10.0448 15 10 14.9552 10 14.9V12.1C10 12.0448 9.95523 12 9.9 12H6.1C6.04477 12 6 12.0448 6 12.1V14.9C6 14.9552 5.95523 15 5.9 15H2.6C2.26863 15 2 14.7314 2 14.4V7.28102C2 7.10296 2.07909 6.93409 2.21589 6.82009Z"
        stroke="currentColor"
      />
    </svg>
  )
}

export const MenuSideTodo = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00009 1.5C6.32811 1.5 5.1854 2.25293 4.47509 3.2C3.78072 4.12583 3.50009 5.23283 3.50009 6V9.84861L1.68772 12.5672C1.42189 12.9659 1.70773 13.5 2.18695 13.5H5.5501C5.78174 14.6411 6.79062 15.5 8.00009 15.5C9.20957 15.5 10.2185 14.6411 10.4501 13.5H13.8132C14.2925 13.5 14.5783 12.9659 14.3125 12.5672L12.5001 9.84861V6C12.5001 5.23283 12.2195 4.12583 11.5251 3.2C10.8148 2.25293 9.67208 1.5 8.00009 1.5ZM9.41474 13.5H6.58545C6.79137 14.0826 7.34699 14.5 8.00009 14.5C8.6532 14.5 9.20882 14.0826 9.41474 13.5ZM4.50009 6C4.50009 5.43384 4.71947 4.54084 5.27509 3.8C5.81479 3.08041 6.67208 2.5 8.00009 2.5C9.32811 2.5 10.1854 3.08041 10.7251 3.8C11.2807 4.54084 11.5001 5.43384 11.5001 6V10V10.1514L11.5841 10.2774L13.0658 12.5H2.93435L4.41612 10.2774L4.50009 10.1514V10V6Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const MenuWorkOrder = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.2 0.5C4.8134 0.5 4.5 0.813401 4.5 1.2V1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V14C1.5 14.8284 2.17157 15.5 3 15.5H13C13.8284 15.5 14.5 14.8284 14.5 14V3C14.5 2.17157 13.8284 1.5 13 1.5H11.5V1.2C11.5 0.813401 11.1866 0.5 10.8 0.5H5.2ZM11.5 2.5V3V3.8C11.5 4.1866 11.1866 4.5 10.8 4.5H5.2C4.8134 4.5 4.5 4.1866 4.5 3.8V2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V14C2.5 14.2761 2.72386 14.5 3 14.5H13C13.2761 14.5 13.5 14.2761 13.5 14V3C13.5 2.72386 13.2761 2.5 13 2.5H11.5ZM10.5 3.5H5.5V1.5H10.5V3V3.5ZM5 8.5L11 8.5V7.5L5 7.5V8.5ZM9 11.5H5V10.5H9V11.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const MenuDownload = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.50006 1L7.50001 9.2376L4.36855 6.10614L3.66145 6.81325L7.64647 10.7983L8.00009 11.1519L8.35364 10.7982L12.3372 6.81318L11.6299 6.10621L8.50001 9.2373L8.50006 1.00001L7.50006 1ZM3 14.4434C2.72386 14.4434 2.5 14.2195 2.5 13.9434L2.5 9.94336H1.5L1.5 13.9434C1.5 14.7718 2.17157 15.4434 3 15.4434L13 15.4434C13.8284 15.4434 14.5 14.7718 14.5 13.9434V9.94336H13.5V13.9434C13.5 14.2195 13.2761 14.4434 13 14.4434L3 14.4434Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const MenuDownArrow = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="&#229;&#155;&#190;&#230;&#160;&#135;16px/&#231;&#174;&#173;&#229;&#164;&#180;/1&#228;&#184;&#139;&#230;&#139;&#137;&#231;&#174;&#173;&#229;&#164;&#180;/ChevronDown &#229;&#144;&#145;&#228;&#184;&#139;&#231;&#174;&#173;&#229;&#164;&#180;">
        <path
          id="Vector"
          d="M4.17757 5.76573L7.99993 9.58809L11.8208 5.76573"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}

export const MenuApplication = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="&#229;&#155;&#190;&#230;&#160;&#135;16px/&#233;&#128;&#154;&#231;&#148;&#168;/AppMarket &#229;&#186;&#148;&#231;&#148;&#168;&#228;&#184;&#173;&#229;&#191;&#131;">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.93098 0C1.8817 0 1.01082 0.810893 0.936059 1.85751L0.0789161 13.8575C-0.00377923 15.0152 0.913149 16 2.07383 16H13.9259C15.0866 16 16.0035 15.0152 15.9208 13.8575L15.0637 1.85751C14.9889 0.810895 14.118 0 13.0687 0H2.93098ZM2.93098 2L13.0687 2L13.9259 14H2.07383L2.93098 2ZM6.99986 5V4H4.99986V5C4.99986 6.65685 6.343 8 7.99986 8C9.65671 8 10.9999 6.65685 10.9999 5V4H8.99986V5C8.99986 5.55228 8.55214 6 7.99986 6C7.44757 6 6.99986 5.55228 6.99986 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export const IconPinOff = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="pin&#230;&#160;&#135;&#232;&#175;&#134;">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2.5C6 2.22386 6.22386 2 6.5 2H9.5C9.77615 2 10 2.22386 10 2.5V7C10 7.11354 10.0386 7.22369 10.1096 7.31235L11.4597 9H4.54032L5.89044 7.31235C5.96136 7.22369 6 7.11354 6 7V2.5ZM6.5 1C5.67158 1 5 1.67157 5 2.5V6.82461L3.10957 9.18765C2.9895 9.33774 2.96609 9.54336 3.04935 9.71659C3.13261 9.88983 3.3078 10 3.5 10H7.04763L7.50261 14.5498C7.52817 14.8054 7.74325 15 8.00013 15C8.257 15 8.47209 14.8054 8.49765 14.5498L8.95262 10H12.5C12.6922 10 12.8674 9.88983 12.9507 9.71659C13.0339 9.54336 13.0105 9.33774 12.8904 9.18765L11 6.82461V2.5C11 1.67157 10.3284 1 9.5 1H6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export const IconPin = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="pin&#230;&#160;&#135;&#232;&#175;&#134;">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 1C5.67158 1 5 1.67157 5 2.5V6.82461L3.10957 9.18765C2.9895 9.33774 2.96609 9.54336 3.04935 9.71659C3.13261 9.88983 3.3078 10 3.5 10H7.04753L7.5025 14.5498C7.52806 14.8054 7.74315 15 8.00002 15C8.2569 15 8.47198 14.8054 8.49754 14.5498L8.95252 10H12.5C12.6922 10 12.8674 9.88983 12.9507 9.71659C13.0339 9.54336 13.0105 9.33774 12.8904 9.18765L11 6.82461V2.5C11 1.67157 10.3284 1 9.5 1H6.5Z"
          fill="currentColor"
          // stroke="#2D2D2E"
        />
      </g>
    </svg>
  )
}

// 业务配置
export const SvgBizConfigIcon = props => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.99 13.5906V0.99H4.63127H13.0494V4.40009H14.0394V0.704085C14.0394 0.31523 13.7242 0 13.3353 0H4.63127H2.70409C2.31523 0 2 0.315231 2 0.704086V13.8765C2 14.2653 2.31523 14.5806 2.70409 14.5806H6.247V13.5906H2.99ZM5 4.495H9.752V3.505H5V4.495ZM7.376 7.495H5V6.505H7.376V7.495ZM11.5269 4.43195C11.8003 4.43195 12.0219 4.65357 12.0219 4.92695V5.54466C12.6217 5.75027 13.0528 6.31907 13.0528 6.98856C13.0528 7.46305 12.8363 7.88696 12.4966 8.16685L14.0713 12.3661C14.3082 12.2538 14.5365 12.1262 14.7549 11.9848C14.9844 11.8362 15.2909 11.9018 15.4395 12.1312C15.5881 12.3607 15.5225 12.6672 15.293 12.8158C15.0151 12.9958 14.7234 13.1564 14.42 13.2958L15.0835 15.0652C15.1795 15.3212 15.0498 15.6065 14.7938 15.7025C14.5378 15.7985 14.2525 15.6688 14.1565 15.4128L13.493 13.6435C12.8693 13.8275 12.2091 13.9263 11.5262 13.9263C10.8438 13.9263 10.1839 13.8276 9.56049 13.6438L8.89711 15.4128C8.80112 15.6688 8.51579 15.7985 8.25982 15.7025C8.00384 15.6065 7.87415 15.3212 7.97014 15.0652L8.63349 13.2963C8.32971 13.1568 8.03773 12.996 7.75949 12.8158C7.53001 12.6672 7.46445 12.3607 7.61304 12.1312C7.76163 11.9018 8.06811 11.8362 8.29758 11.9848C8.51631 12.1264 8.74491 12.2541 8.98215 12.3665L10.557 8.16684C10.2174 7.88696 10.0008 7.46305 10.0008 6.98856C10.0008 6.319 10.432 5.75016 11.0319 5.5446V4.92695C11.0319 4.65357 11.2535 4.43195 11.5269 4.43195ZM11.5269 6.45296L11.5124 6.45275C11.223 6.4604 10.9908 6.69737 10.9908 6.98856C10.9908 7.15275 11.0646 7.29969 11.1809 7.39801C11.241 7.39709 11.3024 7.4072 11.3621 7.4296C11.4217 7.45192 11.4743 7.48447 11.519 7.52451L11.5268 7.52457L11.5346 7.52451C11.5793 7.48447 11.6319 7.45192 11.6915 7.4296C11.7512 7.4072 11.8126 7.39709 11.8727 7.39801C11.989 7.29969 12.0628 7.15275 12.0628 6.98856C12.0628 6.69739 11.8306 6.46045 11.5413 6.45275L11.5269 6.45296ZM13.1443 12.7137L11.5694 8.51398C11.5553 8.51437 11.5411 8.51457 11.5268 8.51457C11.5125 8.51457 11.4983 8.51437 11.4842 8.51398L9.90916 12.714C10.4231 12.8588 10.9655 12.9363 11.5262 12.9363C12.0874 12.9363 12.6301 12.8587 13.1443 12.7137Z"
      fill="currentColor"
    />
  </svg>
)

// 侧边栏 用户缺省头像
export const SvgUserSmall = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props}>
    <path
      fill="#0064FF"
      fillRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M4.5 19.349V18c0-1.877 4.57-3 7.5-3s7.5 1.113 7.5 3v1.349A10.47 10.47 0 0 1 12 22.5a10.47 10.47 0 0 1-7.5-3.151M16.5 9a4.5 4.5 0 1 0-9 0 4.5 4.5 0 1 0 9 0"
      clipRule="evenodd"
    />
  </svg>
)

export const TrashIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 1.5H5V0.5H11V1.5ZM2.5 4.5H0V3.5H16V4.5H13.5V14C13.5 14.8284 12.8284 15.5 12 15.5H4C3.17157 15.5 2.5 14.8284 2.5 14V4.5ZM3.5 4.5V14C3.5 14.2761 3.72386 14.5 4 14.5H12C12.2761 14.5 12.5 14.2761 12.5 14V4.5H3.5ZM6.5 12V7H5.5V12H6.5ZM10.5 7V12H9.5V7H10.5Z"
      fill="#E83723"
    />
  </svg>
)
export const EditIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.92804 3.82843L3.17415 8.58232C3.04599 8.71048 2.95507 8.87106 2.91112 9.04689L1.96831 12.8181C1.78521 13.5505 2.44861 14.2139 3.18099 14.0308L6.95222 13.088C7.12805 13.044 7.28863 12.9531 7.41679 12.825L12.1707 8.07107M7.92804 3.82843L10.0494 1.70711C10.4399 1.31658 11.0731 1.31658 11.4636 1.70711L14.292 4.53553C14.6825 4.92606 14.6825 5.55922 14.292 5.94975L12.1707 8.07107M7.92804 3.82843L12.1707 8.07107"
      stroke="#0064FF"
    />
  </svg>
)

export const OrderEdit = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H9V1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V13C1.5 13.8284 2.17157 14.5 3 14.5H13C13.8284 14.5 14.5 13.8284 14.5 13V7H13.5V13C13.5 13.2761 13.2761 13.5 13 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V3ZM13.8848 2.8223L14.2384 2.46875L13.5312 1.76164L13.1777 2.1152L6.1152 9.1777L5.76164 9.53125L6.46875 10.2384L6.8223 9.8848L13.8848 2.8223Z"
      fill="#575859"
    />
  </svg>
)
